/* eslint-disable react-hooks/exhaustive-deps */
import LeftArrow from 'icons/black.svg';
import { ReactNode, useState } from 'react';
import { SearchProps } from 'react-vant/es/search';
import { cls } from 'reactutils';
import DrawerTree from './DrawerTree';

export default function SearchTree({
  placeholder = '请选择',
  value = {},
  title,
  change,
  name = 'name',
  orgParams,
}: SearchProps & {
  slot?: ReactNode;
  value?: any;
  title?: string;
  change: Function;
  name?: string;
  onClickSearchIcon?: () => void;
  orgParams?: any;
}) {
  const [opened, setOpened] = useState(false);

  const changeTree = (e) => {
    change(e);
  };

  return (
    <>
      <div className="itemWrap">
        <div className="itemTitle">{title}</div>
        <div className={cls('text-panel')} onClick={() => setOpened(!opened)}>
          <div className={cls('current-box')}>{value?.[name] ?? placeholder}&nbsp;</div>
          <LeftArrow />
        </div>
        <DrawerTree
          value={value}
          visible={opened}
          change={changeTree}
          onClose={() => setOpened(false)}
          params={orgParams}
        />
      </div>
      <style jsx>{`
        .custom-search {
          background-color: #fff;
          border: 1px solid #f1f1f1;
          border-radius: 0 0 3px 3px;
        }
        .text-panel {
          background: #f2f2f2;
          border-radius: 3px;
          display: flex;
          justify-content: space-between;
          padding: 13px 16px;
        }
        .itemWrap {
          padding: 10px 20px 17px 20px;
          border-bottom: 2px solid #f9f9f9;
        }
        .itemWrap:last-child {
          border-bottom: none;
        }

        .itemTitle {
          font-size: 15px;
          color: #262626;
          line-height: 13px;
          font-weight: bold;
          margin-bottom: 17px;
        }
        .back-box {
          display: flex;
          align-items: center;
          width: 20px;
          justify-content: flex-end;
        }
        .back-box :global(svg) {
          height: 14px;
        }
        .icon-box :global(svg) {
          transform: translateY(2px);
        }
        .custom-search :global(.rv-search__content) {
          align-items: center;
          height: 40px;
          background: #f2f2f2;
          border-radius: 3px;
        }
        .custom-search :global(.rv-search) {
          flex: 1;
        }
        .text-panel :global(svg) {
          transform: translate(2px, 4px) rotate(-90deg);
        }
        .open-pop :global(svg) {
          transform: translate(2px, 4px) rotate(90deg);
        }
        .search-list {
          max-height: 200px;
          overflow: hidden;
          overflow-y: auto;
        }
        .list-item {
          height: 40px;
          line-height: 40px;
          padding: 0 13px;
          font-size: 14px;
          color: #333333;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
        .active {
          color: var(--primaryColor);
        }
        .nodata {
          font-size: 14px;
          color: #333333;
          text-align: center;
          padding-top: 10px;
          padding-bottom: 20px;
        }

        .close-box {
          display: flex;
          justify-content: flex-end;
          height: 40px;
          align-items: center;
          padding-right: 12px;
        }
      `}</style>
    </>
  );
}
